import React from 'react';
import { Mail, Linkedin, Github, Twitter } from 'lucide-react';
import { profileData } from '../mock/data';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-cyan-600 mt-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Left: Name and Role */}
          <div className="space-y-4">
            <h3 className="font-serif text-2xl text-white">
              Uddeshya Barnwal
            </h3>
            <p className="text-base text-teal-50 font-medium">
              AI Research Engineer
            </p>
            <p className="text-sm text-teal-100">
              © {currentYear} All rights reserved
            </p>
          </div>

          {/* Right: Contact Information */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-white uppercase tracking-wide">
              Contact
            </h4>
            <div className="space-y-3">
              <a
                href={`mailto:${profileData.email}`}
                className="flex items-center gap-3 text-teal-50 hover:text-white transition-colors duration-300"
              >
                <Mail size={18} />
                <span className="text-sm">{profileData.email}</span>
              </a>
              <div className="flex gap-4 pt-2">
                <a
                  href="https://www.linkedin.com/in/uddeshya-barnwal-b02510100/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-teal-50 hover:text-white transition-colors duration-300"
                  aria-label="LinkedIn"
                >
                  <Linkedin size={20} />
                </a>
                <a
                  href="https://github.com/buddeshya"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-teal-50 hover:text-white transition-colors duration-300"
                  aria-label="GitHub"
                >
                  <Github size={20} />
                </a>
                <a
                  href="https://x.com/BarnwalUddeshya"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-teal-50 hover:text-white transition-colors duration-300"
                  aria-label="Twitter"
                >
                  <Twitter size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
